import { render, staticRenderFns } from "./SSProductSelector.vue?vue&type=template&id=227c1bd5&scoped=true&"
import script from "./SSProductSelector.vue?vue&type=script&lang=js&"
export * from "./SSProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./SSProductSelector.vue?vue&type=style&index=0&id=227c1bd5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c1bd5",
  null
  
)

export default component.exports